import _debounce from "lodash.debounce";

const debounce = (wait, options) => (func) => _debounce(func, wait, options);

export default debounce;
